<div class="p-0 mb-0 mt-[2px]">
  <div class="w-full h-full pl-[0px] pr-[30px] z-20 flex gap-[10px]">
    <div class="flex justify-start pb-[0px] !w-[26.8125rem]">
      <mat-form-field appearance="outline">
        <mat-label>Select Measurement Standard</mat-label>
        <mat-select
          [(value)]="selectedCategory"
          (selectionChange)="onCategoryChange()"
          [compareWith]="compareCategories"
        >
          <mat-option
            class="hover:!bg-[#fae8e1] border-b"
            *ngFor="let category of categories"
            [value]="category"
          >
            {{ category.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      *ngIf="selectedCategory?.name === 'CUSTOM'"
      class="flex justify-start !w-[30%]"
    >
      <mat-form-field appearance="outline">
        <mat-label>Select Sub Package</mat-label>
        <mat-select
          [(value)]="selectedSubCategory"
          (selectionChange)="onSubCategoryChange()"
        >
          <mat-option
            class="hover:!bg-[#fae8e1] !border-b"
            *ngFor="let subCategory of subCategories"
            [value]="subCategory"
          >
            {{ subCategory?.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
